"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var api_1 = __importDefault(require("api"));
var UserStore_1 = require("stores/UserStore");
var QueriesStore_1 = require("stores/QueriesStore");
var Notification_1 = require("components/core/Notification");
var use_notification_1 = require("hooks/use-notification");
var Dialog_1 = require("components/core/Dialog");
var use_dialog_1 = require("hooks/use-dialog");
var use_stores_1 = require("hooks/use-stores");
var IPCTable_1 = __importDefault(require("./IPCTable"));
var Select_1 = __importDefault(require("components/core/inputs/Select"));
var Loading_1 = __importDefault(require("components/core/Loading"));
var mobx_react_1 = require("mobx-react");
var InfoRow_1 = __importDefault(require("components/core/common/InfoRow"));
var TextInput_1 = __importDefault(require("../../../../core/inputs/TextInput"));
var dayjs_1 = __importDefault(require("dayjs"));
var Button_1 = __importDefault(require("../../../../core/buttons/Button"));
var FileInput_1 = __importDefault(require("../../../../core/inputs/FileInput"));
var config_1 = __importDefault(require("config"));
var getCurrency = function (country) {
    return country === QueriesStore_1.Countries.IR ? "€" : "£";
};
var FleetQueryStage2 = mobx_react_1.observer(function (_a) {
    var data = _a.data;
    var _b = react_1.useState(null), files = _b[0], setFiles = _b[1];
    var _c = react_1.useState(false), busy = _c[0], setBusy = _c[1];
    var _d = react_1.useState(null), rowDeleteID = _d[0], setRowDeleteID = _d[1];
    var _e = react_1.useState(null), rowEditID = _e[0], setRowEditID = _e[1];
    var notification = use_notification_1.useNotification();
    var dialog = use_dialog_1.useDialog();
    var _f = use_stores_1.useStores(), userStore = _f.userStore, queriesStore = _f.queriesStore;
    var history = react_router_dom_1.useHistory();
    var timeoutRef = react_1.useRef(null);
    var changeHandler = function (e) {
        var _a;
        var value = e.currentTarget.value;
        api_1.default.patchQuery(data.id, (_a = {},
            _a[e.currentTarget.name] = value,
            _a))
            .then(function (response) {
            queriesStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Query updated"
            });
        }, function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error updating query"
            });
        });
    };
    var changeTextHandler = function (e) {
        var _a;
        var value = e.currentTarget.value;
        clearTimeout(timeoutRef.current);
        var dataObject = (_a = {},
            _a[e.currentTarget.name] = value,
            _a);
        timeoutRef.current = setTimeout(function () { return api_1.default.patchQuery(data.id, dataObject)
            .then(function (response) {
            queriesStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Query updated"
            });
        }, function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error updating query"
            });
        }); }, 1500);
    };
    var fileSelectHandler = function (name, files) {
        setFiles(files);
    };
    var fileErrorHandler = function (error) {
        notification({
            variant: Notification_1.NotificationVariants.ERROR,
            message: error
        });
    };
    var uploadHandler = function (e) {
        if (files.length <= 0) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Please select a file"
            });
        }
        var formData = new FormData();
        formData.append("_method", "PUT");
        formData.append("ipcFile", files[0]);
        formData.append("id", data.id.toString());
        setBusy(true);
        api_1.default.uploadIPC(data.id, formData)
            .then(function (response) {
            setBusy(false);
            setFiles(null);
            queriesStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Upload successful"
            });
        }, function (error) {
            setBusy(false);
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error.response.data.message
            });
        });
    };
    var deleteRowHandler = function (id) {
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Delete IPC Row",
            description: "Are you sure you want to delete this row?"
        })
            .then(function (response) {
            api_1.default.deleteFleetIPCRow(id)
                .then(function (response) {
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Row Successfully Deleted"
                });
                setRowDeleteID(id);
            });
        });
    };
    var editRowHandler = function (id) {
        if (rowEditID !== null) {
            dialog({
                variant: Dialog_1.DialogVariants.CONFIRMATION,
                title: "Discard Changes?",
                description: "Are you sure you want to discard your current edit?"
            })
                .then(function (response) {
                setRowEditID(id);
            });
            return;
        }
        setRowEditID(id);
    };
    var saveRowHandler = function (row) {
        setBusy(true);
        api_1.default.editFleetIPCRow(row)
            .then(function (response) {
            setBusy(false);
            queriesStore.editDataItem(response.data);
            setRowEditID(null);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Row Successfully Saved"
            });
        }, function (error) {
            setBusy(false);
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error.response.data.title
            });
        });
    };
    react_1.useEffect(function () {
        var timer = setTimeout(function () {
            queriesStore.editDataItem(__assign(__assign({}, data), { fleetQuery: __assign(__assign({}, data.fleetQuery), { fleetQueryIPCs: data.fleetQuery.fleetQueryIPCs.filter(function (item) { return item.id !== rowDeleteID; }) }) }));
            setRowDeleteID(null);
        }, 400);
        return function () { return clearTimeout(timer); };
    }, [rowDeleteID]);
    var addRowHandler = function (row) {
        setBusy(true);
        api_1.default.addIPCRow(data.id, row)
            .then(function (response) {
            setBusy(false);
            queriesStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Row Successfully Added"
            });
        }, function (error) {
            setBusy(false);
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error.response.data.title
            });
        });
    };
    var getTotals = function () {
        var totals = { dr: 0, cr: 0 };
        for (var _i = 0, _a = data.fleetQuery.fleetQueryIPCs; _i < _a.length; _i++) {
            var ipcRow = _a[_i];
            totals.dr += ipcRow.newNet * ipcRow.quantity - ipcRow.itemNet * ipcRow.quantity;
            totals.cr += ipcRow.newNet - ipcRow.itemNet;
        }
        return totals;
    };
    var closeHandler = function () {
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Close this query?",
            description: "Are you sure you want to close this query? Please make sure are ok for this query to be closed and leave your comments below to explain the reason for this closure.",
            withComment: true,
            queryId: data.id,
            stage: data.currentStage,
            direction: "Forward"
        })
            .then(function (response) {
            api_1.default.closeQuery(data.id, { currentStage: 2 })
                .then(function (response) {
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Query closed!"
                });
                queriesStore.editDataItem(response.data);
                setTimeout(function () {
                    history.replace("/");
                }, 1000);
            }, function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Query could not be closed due to an error"
                });
            });
        });
    };
    return (react_1.default.createElement("div", { className: "price-query-stage-2" },
        react_1.default.createElement("div", { className: "flex flex-row" },
            react_1.default.createElement("div", { className: "half" },
                react_1.default.createElement(InfoRow_1.default, { label: "Account Number", value: data.acNumber }),
                data.queryStage.stage === 2 &&
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(Select_1.default, { name: "queryAction", value: data.fleetQuery.queryAction || "", onChange: changeHandler, options: Object.keys(QueriesStore_1.QueryActions).filter(function (key) { return isNaN(parseInt(key)); })
                            .map(function (key) { return ({
                            value: QueriesStore_1.QueryActions[key],
                            text: QueriesStore_1.QueryActions[key]
                        }); }) }) :
                    react_1.default.createElement(InfoRow_1.default, { label: "Query Action", value: data.fleetQuery.queryAction || "None Selected" }),
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.queryStage.stage === 2 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(TextInput_1.default, { type: "number", step: 0.1, placeholder: "Total Invoice Value", name: "totalInvoiceValue", defaultValue: data.totalInvoiceValue === null ? "" : data.totalInvoiceValue, onChange: changeTextHandler }) :
                    react_1.default.createElement(InfoRow_1.default, { label: "Total Invoice(s) Value", value: data.totalInvoiceValue === null ? "" : parseFloat(data.totalInvoiceValue).toFixed(2) }),
                data.queryStage.stage === 2 &&
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(Select_1.default, { name: "initialAuthoriser", value: data.fleetQuery.initialAuthoriser !== null ? data.fleetQuery.initialAuthoriser.id : "", onChange: changeHandler, options: Object.keys(QueriesStore_1.FleetQueryAuthorisers).filter(function (key) { return isNaN(parseInt(key)); })
                            .map(function (key) { return ({
                            value: QueriesStore_1.FleetQueryAuthoriserIDs[key],
                            text: QueriesStore_1.FleetQueryAuthorisers[key]
                        }); }) })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Initial Authoriser", value: data.fleetQuery.initialAuthoriser === null && "Not Set" || data.fleetQuery.initialAuthoriser.fullName })),
            react_1.default.createElement("div", { className: "half" },
                react_1.default.createElement(InfoRow_1.default, { label: "Customer Name", value: data.customer }),
                data.queryStage.stage === 2 &&
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(TextInput_1.default, { type: "date", name: "dueDate", value: data.dueDate === null && "" || dayjs_1.default(data.dueDate).format("YYYY-MM-DD"), onChange: changeHandler })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Due Date", value: data.dueDate === null && "Not Set" || dayjs_1.default(data.dueDate).format("YYYY-MM-DD") }),
                react_1.default.createElement(InfoRow_1.default, { label: "Total DR/CR Value", negativeValue: getTotals().dr < 0, value: getTotals().dr.toFixed(2) }))),
        react_1.default.createElement("div", { className: "attachments no-input" },
            react_1.default.createElement("span", { className: "subtitle" }, "Attachments"),
            react_1.default.createElement("ul", null, data.attachments.length <= 0 ?
                react_1.default.createElement("p", null, "There are no attachments")
                :
                    data.attachments.map(function (attachment) { return (react_1.default.createElement("li", { key: attachment.id },
                        react_1.default.createElement("a", { href: config_1.default.api_base + "/attachment/" + attachment.id, title: attachment.fileName }, attachment.fileName))); }))),
        data.status === QueriesStore_1.QueryStatus.ACTIVE &&
            data.queryStage.stage === 2 &&
            userStore.hasPermission(UserStore_1.Permissions.STAGE_2) &&
            react_1.default.createElement("div", { className: "spreadsheet-upload flex flex-row" },
                react_1.default.createElement(FileInput_1.default, { name: "uploadSpreadsheet", accept: ".csv,.xls,.xlsx", multiple: false, files: files, onFileError: fileErrorHandler, onFileSelect: fileSelectHandler }),
                react_1.default.createElement(Button_1.default, { type: "button", title: "Upload", icon: busy ? react_1.default.createElement(Loading_1.default, null) : null, onClick: uploadHandler }, "Upload")),
        react_1.default.createElement("div", { className: "ipc-table-container" },
            react_1.default.createElement(IPCTable_1.default, { type: data.queryType.id, editable: data.status === QueriesStore_1.QueryStatus.ACTIVE && data.queryStage.stage === 2 && userStore.hasPermission(UserStore_1.Permissions.STAGE_2), queryAction: data.fleetQuery.queryAction, data: data.fleetQuery.fleetQueryIPCs, deleteRow: deleteRowHandler, rowDeleteID: rowDeleteID, editRow: editRowHandler, rowEditID: rowEditID, addRow: addRowHandler, saveRow: saveRowHandler, busy: busy, queries: queriesStore.data, country: data.country })),
        data.status === QueriesStore_1.QueryStatus.ACTIVE &&
            data.queryStage.stage === 2 &&
            userStore.hasPermission(UserStore_1.Permissions.STAGE_2) &&
            react_1.default.createElement(Button_1.default, { className: "button close-button", type: "button", onClick: closeHandler, title: "Close Query" }, "Close Query")));
});
exports.default = FleetQueryStage2;
